export const AuthTokenKey = ['Auth', 'token'];
export const ThoughtCatcherBotStateKey = ['ThoughtCatcher', 'Bot', 'StateSnapshot'];
export const LocalThoughtCacheKey = ['ThoughtCatcher', 'UnpublishedThought'];